module.exports = __webpack_public_path__ + "static/img/Matt-Moylan.a2be2ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete/Matt-Moylan.jpg
// module id = ZR7w
// module chunks = 0